export default __webpack_public_path__ + "static/media/logoNew.6423b1aa.png";